<!-- title -->
<app-modal-title
  [title]="title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form" autocomplete="off">
    <div class="row">
      <div class="tw-w-full">
        <div class="tw-flex-center tw-flex-col">
          <!-- title -->
          <form-field
            [(value)]="model.title"
            class="tw-w-full tw-mb-2"
            [control]="form?.get('title')"
            label="common.title"
          >
          </form-field>

          <!--category-->
          <enum-select-search
            class="tw-w-full"
            enumName="CalenderEventCategories"
            label="common.category"
            [control]="form?.get('category')"
            [(value)]="model.category"
            (onError)="onClose()"
          >
          </enum-select-search>

          <!-- body -->
          <form-textarea
            class="tw-w-full"
            label="common.description"
            [(value)]="model.description"
            [control]="form?.get('description')"
            [rows]="5"
            [spellcheck]="false"
            autocomplete="off"
          >
          </form-textarea>

          <div *ngIf="isCalenderEventMode" class="tw-w-full tw-my-1">
            <mat-slide-toggle
              formControlName="isHoliday"
              [(ngModel)]="model.isHoliday"
            >
              {{ "common.holiday" | translate }}</mat-slide-toggle
            >
          </div>
        </div>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
